import { Directive, HostListener, Input, inject } from '@angular/core';

import { WootricService } from '../../core/services/wootric.service';

export interface WootricProperties {
  updatedEmployees_amount: number;
  failedEmployees_amount: number;
  totalEmployees_amount: number;
}

@Directive({
  selector: '[diWootric]',
  standalone: false,
})
export class WootricDirective {
  private wootricService = inject(WootricService);

  @Input() wootricEventName: string;
  @Input() properties: WootricProperties;

  @HostListener('click')
  onClick() {
    this.wootricService.addWootric(this.wootricEventName, this.properties);
  }
}
